module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/produtos.json
// module id = 459
// module chunks = 82487553268452